import { sendMessageToParentWindow } from "./sendMessageToParentWindow";

export const playSound = () => {
  sendMessageToParentWindow("play_sound");
};
